import { render, staticRenderFns } from "./Sop.vue?vue&type=template&id=dbd66758&scoped=true"
import script from "./Sop.vue?vue&type=script&lang=ts"
export * from "./Sop.vue?vue&type=script&lang=ts"
import style0 from "./Sop.vue?vue&type=style&index=0&id=dbd66758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd66758",
  null
  
)

export default component.exports